import { fieldServiceTypeOptions } from "@/common/const/filter-options";
import fieldServiceHoursOptions from "@/common/const/filter-options/fieldServiceHours.options";
import { FormFieldsStrategyType } from "@/common/types";

const fieldServiceManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "select",
    label: "Hours Type",
    name: "hoursType",
    required: true,
    options: fieldServiceHoursOptions,
  },
  {
    inputType: "text",
    label: "No. of Hours",
    name: "noOfHours",
    required: true,
    pattern: /^[2-8]$/,
    errorMessage: "The value must be an integer between 2 and 8.",
    patternMessage: "The value must be an integer between 2 and 8.",
  },
  {
    inputType: "select",
    label: "Field Service Type",
    name: "fieldServiceType",
    options: fieldServiceTypeOptions,
    required: true,
  },
];
export default fieldServiceManualFormStrategy;
